import React from 'react';
import moment from 'moment';

/**
 * @typedef {object} TimeTrackerProps
 * @property {number} [createdAt]
 */

/**
 * @param {TimeTrackerProps} props
 */
const TimeTracker = props => {
  const { createdAt } = props;
  const date = moment(createdAt);
  const foramtedDate = `${date.format('MMMM D, YYYY')} at ${date.format('hh:mm A')}`;
  return <span title={foramtedDate}>{date.fromNow()}</span>;
};

export default TimeTracker;
